/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { use, useEffect, useRef } from 'fierry/react';

import Auth from 'solis/auth';
import Rpc from 'fierry/rpc';


export default (props) =>
{
  const rpc = use(Rpc);

  const open = use(Rpc(rpc => rpc.open));
  const token = use(Auth(auth => auth.token));

  const previous = useRef(null);

  const effectCallback = () =>
  {
    if (open && token)
    {
      rpc.send('', 'user/login', token);
    }
    else if (open && previous.current)
    {
      rpc.send('', 'user/logout', {});
    }

    previous.current = token;
  };

  useEffect(effectCallback, [ open, token ]);

  return null;
};
